import { theme } from 'Assets/Styles/theme'

const styles = {
  wrapper: {
    marginBottom: '24px',
    '& .MuiBox-root': {
      fontFamily: "'Proxima Nova', sans-serif !important",
    },
  },

  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginBottom: '8px',
  },

  text: {
    fontSize: '14px',
    fontWeight: '400',
    fontFamily: "'Proxima Nova', sans-serif",
    color: '#011533',
    marginTop: '12px',
    marginBottom: '12px',
  },

  btnWrapper: {
    display: 'flex',

    '& > div:first-child': {
      marginRight: '16px',
    },
  },
  buttonLabel: {
    fontSize: 16,
    color: theme.colors.primary,
  },
  active: {
    '& > p': {
      color: theme.colors.primary,
    },
  },
  disabled: {
    '& > p': {
      color: '#737373',
    },
  },

  noValue: {
    '& > p': {
      color: '#B6B6B6',
    },
  },

  table: {
    textAlign: 'center',
    borderRadius: '4px',

    '&  p': {
      fontSize: '14px',
    },
  },

  tableContainer: {
    maxHeight: '600px',
  },

  tableHead: {
    background: '#F9F9FF !important',
    '& .MuiTableHead-root': {
      background: '#F9F9FF !important',
    },
    '& .MuiTableCell-head': {
      background: '#F9F9FF !important',
    },
  },
  tableRow: {
    marginBottom: 12,
    height: '32px',
    '& > div:first-child': {
      marginBottom: '0px',
    },
    '& td': {
      marginBottom: '0px !important',
      backgroundColor: '#ffffff',
      borderBottom: '1px solid #E2E2FC',
      height: '68px',
    },
    '& .MuiTableCell-root': {
      padding: '0px 16px',
    },
    '& td:nth-child(2)': {
      maxWidth: 400,
      overflow: 'hidden',
    },
    '& td:nth-child(3)': {
      textAlign: 'center',
    },
    '& td:nth-child(4)': {
      textAlign: 'center',
    },
  },

  tableHeaderCell: {
    width: '100px',
    background: '#F9F9FF !important',
    border: 'none',
    fontFamily: "'Proxima Nova', sans-serif",
    fontSize: '14px',
    color: 'red',
  },

  firstTableHeaderCell: {
    width: '50px',
    border: 'none',
    fontFamily: "'Proxima Nova', sans-serif",
    fontSize: '14px',
    fontWeight: '400',
    color: 'red',
  },

  tableValue: {
    width: '100px',
  },

  outlinedInput: {
    padding: '4px',
    textAlign: 'left',
    width: '400px',
    fontFamily: "'Proxima Nova', sans-serif'",
    fontSize: '14px',
    color: '#011533',
  },

  editInput: {
    padding: '4px',
    textAlign: 'left',
    width: '400px',
    backgroundColor: '#E2E2FC',
  },

  tableHeadersLabel: {
    border: 'none',
    fontFamily: "'Proxima Nova', sans-serif",
    fontSize: '14px',
    color: '#707087',
  },

  outlinedNumberInput: {
    padding: '4px',
    textAlign: 'left',

    '& fieldset': {
      border: 'none',
    },
  },

  outlinedInputRoot: {
    width: '300px',
    padding: '4px',
    border: 'none',

    '& fieldset': {
      border: 'none',
    },
  },

  select: {
    height: 30,
    padding: 10,
    borderRadius: 4,
    backgroundColor: '#f8f8f8',
    paddingRight: 20,
    border: 'none',
    '& .MuiSelect-root': {
      backgroundColor: '#f8f8f8',
      width: 200,
      border: 'none',
      paddingLeft: 10,
    },
    '& svg': {
      marginRight: 10,
    },
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: 10,
  },
  rowContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& td': {
      marginBottom: 0,
    },
  },
  comment: {
    minWidth: '100px',
  },
  token: {
    minWidth: '150px',
    width: '100%',
    border: 'solid 1px #E2E2FC',
    padding: '8px',
    borderRadius: '8px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    display: 'block',
    boxSizing: 'border-box',
  },

  label: {
    fontSize: 14,
    fontFamily: "'Proxima Nova', sans-serif",
    borderRadius: 10,
    padding: '4px 10px',
    minWidth: 70,
    display: 'flex',
    justifyContent: 'center',
  },
  labelActive: {
    backgroundColor: '#E0F5E2',
    color: '#00840D',
  },
  labelInactive: {
    backgroundColor: '#E4E4EA',
    color: '#707087',
  },
  labelHidden: {
    display: 'none',
  },
  tokenContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: 0,
  },
}

export default styles
